export const getSelectText = (
  selectValue: string,
  optionsMap: Record<string, string>,
  placeholder?: string
) => {
  if (
    typeof selectValue === 'string' &&
    optionsMap?.hasOwnProperty(selectValue)
  ) {
    return optionsMap[selectValue];
  }
  return placeholder ?? '';
};
